const form = {
  formFieldWrap: {
    clearFieldBtn: 'Löschen',
  },
};

export default form;
